import { render, staticRenderFns } from "./DwellingUnitRangeSlider.vue?vue&type=template&id=21a567cd&scoped=true&"
import script from "./DwellingUnitRangeSlider.vue?vue&type=script&lang=js&"
export * from "./DwellingUnitRangeSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a567cd",
  null
  
)

export default component.exports